export const Viber = ({ width = '14', height = '13', fill = 'white' }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 512.002 512.002"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path
          style={{ fill }}
          d="M437.976,214.854c0.615-72.186-60.866-138.361-137.051-147.512c-1.515-0.18-3.166-0.453-4.913-0.743
              c-3.772-0.625-7.672-1.267-11.607-1.267c-15.614,0-19.788,10.968-20.887,17.51c-1.069,6.36-0.049,11.701,3.024,15.882
              c5.171,7.031,14.269,8.279,21.577,9.28c2.142,0.296,4.163,0.571,5.855,0.951c68.449,15.295,91.497,39.341,102.761,107.208
              c0.275,1.658,0.399,3.702,0.531,5.869c0.491,8.113,1.515,24.991,19.661,24.991h0.002c1.511,0,3.134-0.13,4.824-0.388
              c16.898-2.568,16.368-17.996,16.114-25.409c-0.072-2.088-0.14-4.063,0.037-5.376C437.95,215.519,437.974,215.186,437.976,214.854z"
        />
        <path
          style={{ fill }}
          d="M279.974,40.846c2.027,0.146,3.947,0.286,5.545,0.531c112.4,17.286,164.091,70.54,178.416,183.819
              c0.243,1.926,0.281,4.274,0.321,6.761c0.143,8.85,0.437,27.262,20.21,27.643l0.614,0.006c6.201,0,11.134-1.87,14.662-5.562
              c6.155-6.438,5.726-16.002,5.379-23.689c-0.084-1.886-0.165-3.662-0.145-5.217C506.405,109.283,406.12,4.226,290.369,0.32
              c-0.48-0.016-0.938,0.01-1.401,0.075c-0.227,0.033-0.649,0.075-1.371,0.075c-1.154,0-2.574-0.1-4.08-0.202
              C281.696,0.143,279.632,0,277.54,0c-18.434,0-21.938,13.102-22.386,20.912C254.12,38.963,271.582,40.233,279.974,40.846z"
        />
        <path
          style={{ fill }}
          d="M458.511,371.602c-2.39-1.825-4.861-3.714-7.174-5.578c-12.272-9.876-25.328-18.979-37.955-27.783
              c-2.62-1.825-5.241-3.652-7.852-5.484c-16.174-11.361-30.715-16.882-44.453-16.882c-18.504,0-34.636,10.224-47.951,30.384
              c-5.899,8.938-13.056,13.283-21.876,13.283c-5.215,0-11.142-1.488-17.612-4.425c-52.207-23.674-89.486-59.972-110.803-107.886
              c-10.305-23.158-6.964-38.295,11.172-50.615c10.299-6.99,29.469-20.003,28.111-44.922c-1.538-28.298-63.976-113.445-90.284-123.115
              c-11.138-4.096-22.841-4.134-34.846-0.095C46.744,38.651,25.041,56.506,14.219,80.115c-10.458,22.813-9.986,49.599,1.366,77.463
              C48.401,238.14,94.538,308.38,152.72,366.342c56.95,56.74,126.946,103.217,208.042,138.137c7.31,3.145,14.977,4.861,20.575,6.112
              c1.908,0.429,3.555,0.795,4.756,1.124c0.66,0.18,1.34,0.277,2.023,0.283l0.641,0.003c0.002,0,0,0,0.003,0
              c38.142,0,83.941-34.854,98.007-74.59C499.09,402.618,476.59,385.42,458.511,371.602z"
        />
        <path
          style={{ fill }}
          d="M296.845,132.872c-6.53,0.165-20.121,0.502-24.889,14.344c-2.231,6.468-1.964,12.084,0.795,16.692
              c4.048,6.761,11.805,8.833,18.86,9.97c25.586,4.106,38.726,18.254,41.354,44.522c1.221,12.248,9.469,20.801,20.059,20.801h0.002
              c0.782,0,1.582-0.046,2.379-0.143c12.736-1.515,18.911-10.873,18.353-27.81c0.204-17.677-9.047-37.745-24.781-53.73
              C333.187,141.484,314.156,132.454,296.845,132.872z"
        />
      </g>
    </svg>
  );
};
